import { render } from "./GaleriaItemYoutube.vue?vue&type=template&id=50d7bf99&scoped=true&ts=true"
import script from "./GaleriaItemYoutube.vue?vue&type=script&lang=ts"
export * from "./GaleriaItemYoutube.vue?vue&type=script&lang=ts"

import "./GaleriaItemYoutube.vue?vue&type=style&index=0&id=50d7bf99&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d7bf99"]])

export default __exports__